import { createRef, useEffect, useState } from 'react';
import { Cradle, GetAllLiquidationsFilters, Liquidation, PaginatedEntity } from '@solo/app-core';
import { toast } from 'react-toastify';
import { Button, Flex, InputDateWithLabel, Pagination, StatementsList, Text } from '@/app/ui';

import { translate } from '@/app/i18n';
import Colors from '@/app/styles/Colors';
import { useCradle } from '@/app/contexts';
import DefaultPagination from '@/app/constants/Pagination';

const StatementsPage = () => {
  const { liquidationsBloc } = useCradle<Cradle>();
  const fromDateRef = createRef<HTMLInputElement>();
  const toDateRef = createRef<HTMLInputElement>();

  const [statements, setStatements] = useState<PaginatedEntity<Liquidation>>();

  const getLiquidations = async (filters?: GetAllLiquidationsFilters) => {
    try {
      const liquidations = await liquidationsBloc.getAllLiquidations(filters);
      setStatements(liquidations);
    } catch (error) {
      toast.error('An error ocurred while loading your statements');
    }
  };

  const onSearch = () => {
    getLiquidations({
      dateFrom: fromDateRef.current?.value,
      dateTo: toDateRef.current?.value,
    });
  };

  const jumpToPage = async (page: number) => {
    const pag = { limit: DefaultPagination.limit, offset: DefaultPagination.limit * (page - 1) };
    try {
      getLiquidations({
        ...pag,
        dateFrom: fromDateRef.current?.value,
        dateTo: toDateRef.current?.value,
      });
    } catch (error) {
      toast.error('An error ocurred while loading your statements');
    }
  };

  useEffect(() => {
    getLiquidations();
  }, []);

  return (
    <Flex.Container flexDirection="column" gap="3rem" padding="3rem">
      <Flex.Container>
        <Text.PageTitle color={Colors.purple}>{translate('NAVBAR.EARNINGS')} </Text.PageTitle>
        <Text.Title3>&nbsp;/ {translate('NAVBAR.STATEMENTS')}</Text.Title3>
      </Flex.Container>
      <Flex.Container gap="5rem" flexDirection="column" className="mt-3">
        <Flex.Container
          style={{ width: '70%', height: '40px' }}
          gap="1rem"
          alignContent="center"
          alignItems="center"
          flexWrap="wrap"
        >
          <Flex.Item flex={1}>
            <InputDateWithLabel ref={fromDateRef} />
          </Flex.Item>
          <Flex.Item flex={1}>
            <InputDateWithLabel ref={toDateRef} />
          </Flex.Item>
          <Flex.Item>
            <Button
              $size="md"
              $variant="primary"
              style={{ width: '100%', height: '40px' }}
              onClick={() => onSearch()}
            >
              <Text.Paragraph style={{ padding: 0 }} fontWeight={600}>
                {translate('WORKS.SEARCH')}
              </Text.Paragraph>
            </Button>
          </Flex.Item>
        </Flex.Container>
        {statements && (
          <>
            <StatementsList statements={statements} />
            <Pagination
              totalElements={statements.pagination.totalElements}
              pagination={statements.pagination}
              jumpToPage={(page) => {
                jumpToPage(page);
              }}
              maxDisplayedPages={DefaultPagination.limit}
            />
          </>
        )}
      </Flex.Container>
    </Flex.Container>
  );
};

export default StatementsPage;
